let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jj3sr")).then(() => parcelRequire('kaECc'));